/**
 * DPAAS Tenant API
 * Manage tenants
 *
 * The version of the OpenAPI document: 3.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ServiceProviderProperties } from '../model/serviceProviderProperties';
import { Tenant } from '../model/tenant';
import { TenantCreateParamsNew } from '../model/tenantCreateParamsNew';
import { TenantSettings } from '../model/tenantSettings';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class TenantService {

    protected basePath = 'http://localhost/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Get logo image for the targeted host
     * Get the logo image linked to the targeted host. If none exist or the current tenant is not a Service Provider, the tenant\&#39;s parent logo is returned. When no logo can be found from the parent or the current tenant, a default logo is returned. 
     * @param xForwardedHost The original request host.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLogo(xForwardedHost: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getLogo(xForwardedHost: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getLogo(xForwardedHost: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getLogo(xForwardedHost: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (xForwardedHost === null || xForwardedHost === undefined) {
            throw new Error('Required parameter xForwardedHost was null or undefined when calling getLogo.');
        }

        let headers = this.defaultHeaders;
        if (xForwardedHost !== undefined && xForwardedHost !== null) {
            headers = headers.set('X-Forwarded-Host', String(xForwardedHost));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/png'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/tenants/logo`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the public properties of a Service Provider
     * Get the Service Provider properties if this one is publicly accessible. The Service Provider is identified by the host name part of the \&#39;referer\&#39; header.
     * @param referer URL of the Service Provider
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProperties(referer: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderProperties>;
    public getProperties(referer: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderProperties>>;
    public getProperties(referer: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderProperties>>;
    public getProperties(referer: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (referer === null || referer === undefined) {
            throw new Error('Required parameter referer was null or undefined when calling getProperties.');
        }

        let headers = this.defaultHeaders;
        if (referer !== undefined && referer !== null) {
            headers = headers.set('Referer', String(referer));
        }

        // authentication (OAuth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<ServiceProviderProperties>(`${this.configuration.basePath}/tenants/properties`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get tenant settings
     * Get the tenant settings.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTenantSettings(observe?: 'body', reportProgress?: boolean): Observable<TenantSettings>;
    public getTenantSettings(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantSettings>>;
    public getTenantSettings(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantSettings>>;
    public getTenantSettings(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (OAuth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<TenantSettings>(`${this.configuration.basePath}/tenants/settings`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a tenant (temporary endpoint merged with /tenants ultimately)
     * Create a new tenant.
     * @param referer URL of the Service Provider
     * @param tenantCreateParams Details of the tenant to create.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public signUpTenant(referer: string, tenantCreateParams: TenantCreateParamsNew, observe?: 'body', reportProgress?: boolean): Observable<Tenant>;
    public signUpTenant(referer: string, tenantCreateParams: TenantCreateParamsNew, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Tenant>>;
    public signUpTenant(referer: string, tenantCreateParams: TenantCreateParamsNew, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Tenant>>;
    public signUpTenant(referer: string, tenantCreateParams: TenantCreateParamsNew, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (referer === null || referer === undefined) {
            throw new Error('Required parameter referer was null or undefined when calling signUpTenant.');
        }
        if (tenantCreateParams === null || tenantCreateParams === undefined) {
            throw new Error('Required parameter tenantCreateParams was null or undefined when calling signUpTenant.');
        }

        let headers = this.defaultHeaders;
        if (referer !== undefined && referer !== null) {
            headers = headers.set('Referer', String(referer));
        }

        // authentication (OAuth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Tenant>(`${this.configuration.basePath}/tenants/signups`,
            tenantCreateParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
